(function () {

  'use strict';

  angular.module('PrintixLanguageMenu', ['pascalprecht.translate'])

    .constant('CAPTIONS_URLS', {
      MAIN_URL: 'https://assets.printix.net/captions',
      LOCAL_URL: 'app/assets/captions'
    })

    .constant('RequiredLanguageItemProperties', ['NativeName', 'EnglishName', 'LanguageCode'])

    .constant('PowerPdfUnsupportedLanguages', ['Romanian', 'Hebrew'])

    .controller('LanguageMenuController', function (
      $filter, $http, $log, $ngBootbox, $rootScope, $scope, $translate, amMoment,
      CAPTIONS_URLS, PowerPdfUnsupportedLanguages, RequiredLanguageItemProperties, Utils) {

      $scope.captionListPromise = undefined;
      $scope.captionList = [];

      $scope.changeLanguage = function (languageCode) {
        $scope.captionListPromise.then(function () {
          languageCode = getSupportedLanguageCode(languageCode);
          if (languageCode !== $translate.use()) {
            $translate.use(languageCode)
              .then(function () {
                $log.info('Language changed to: ' + languageCode);
                if (getUserLanguage() !== languageCode) {
                  saveUserLanguage(languageCode);
                }
                setLanguageOfDependencies(languageCode);
                $rootScope.$broadcast('LANGUAGE_CHANGED');
              })
              .catch(function () {
              });
          } else {
            setLanguageOfDependencies(languageCode);
          }
          $log.info('Current language is: ' + $translate.use());
        });
      };

      $scope.getTranslateLanguageCode = function () {
        return $translate.use();
      };

      function getSupportedLanguageCode(languageCode) {
        if (!languageCode) {
          $log.warn('No language code provided, defaulting to English.');
          return 'en';
        }
        const languageCodeLowerCase = languageCode.toLowerCase();
        const foundCaptionItem = $scope.captionList.find(captionItem => captionItem.LanguageCode.toLowerCase() === languageCodeLowerCase);
        if (!foundCaptionItem) {
          $log.warn('Unsupported language code (' + languageCode + ') provided, defaulting to English.');
          return 'en';
        }
        return foundCaptionItem.LanguageCode;
      }

      function getUserLanguage() {
        return $rootScope.currentUser.info._embedded.user.language;
      }

      function saveUserLanguage(languageCode) {
        const objectToSend = [{
          op: 'replace',
          path: '/language',
          value: languageCode
        }];
        $http.patch($rootScope.currentUser.info._embedded.user._links.self.href, objectToSend)
          .then(function (response) {
            $log.info('User language updated to: ' + languageCode);
            $rootScope.currentUser.info._embedded.user = response.data;
          })
          .catch(function () {
          });
      }

      function setLanguageOfDependencies(languageCode) {
        amMoment.changeLocale(languageCode);
        setBootboxLanguage(languageCode);
        setDateRangePickerLanguage();
      }

      function setBootboxLanguage(languageCode) {
        $ngBootbox.addLocale(languageCode, {
          OK: $filter('translate')('Ok'),
          CANCEL: $filter('translate')('Cancel'),
          CONFIRM: $filter('translate')('Confirm')
        });
        $ngBootbox.setLocale(languageCode);
      }

      function setDateRangePickerLanguage() {
        $rootScope.dateRangePickerLanguage = {
          separator: '-',
          applyLabel: $filter('translate')('Apply'),
          cancelLabel: $filter('translate')('Cancel'),
          fromLabel: $filter('translate')('From'),
          toLabel: $filter('translate')('To'),
          customRangeLabel: $filter('translate')('Custom'),
          daysOfWeek: [
            $filter('translate')('SundayShort'),
            $filter('translate')('MondayShort'),
            $filter('translate')('TuesdayShort'),
            $filter('translate')('WednesdayShort'),
            $filter('translate')('ThursdayShort'),
            $filter('translate')('FridayShort'),
            $filter('translate')('SaturdayShort')
          ],
          monthNames: [
            $filter('translate')('January'),
            $filter('translate')('February'),
            $filter('translate')('March'),
            $filter('translate')('April'),
            $filter('translate')('May'),
            $filter('translate')('June'),
            $filter('translate')('July'),
            $filter('translate')('August'),
            $filter('translate')('September'),
            $filter('translate')('October'),
            $filter('translate')('November'),
            $filter('translate')('December')
          ]
        };
      }

      function loadCaptions() {
        $scope.captionListPromise = $http.get(CAPTIONS_URLS.MAIN_URL + '/Captions.2025.4.json', { cache: true })
          .then(function (response) {
            $scope.captionList = verifyAndFilterCaptions(response.data.Languages);
            $rootScope.sharedCaptionList = $scope.captionList;
          })
          .catch(function () {
          });
      }

      function verifyAndFilterCaptions(captionList) {
        const isPowerPdfOnly = $rootScope.TenantListService.currentTenant.isPowerPDFOnly();
        return captionList.filter(function (captionItem) {
          if (!Utils.objectPropertiesCheck(captionItem, RequiredLanguageItemProperties)) {
            $log.error('Invalid caption object.');
            return false;
          }
          return !isPowerPdfOnly || !PowerPdfUnsupportedLanguages.includes(captionItem.EnglishName);
        });
      }

      loadCaptions();

      // eslint-disable-next-line angular/on-watch
      $rootScope.$watch(getUserLanguage, function (languageCode) {
        $scope.changeLanguage(languageCode);
      });

    })

    // Use main captions from assets, but override with local captions in app/assets/captions/Caption_Admin_en.json if available.
    // This is convenient for canary branches, but captions should be moved to the captions repo for production.
    .factory('customCaptionLoader', function ($http, $q) {
      return function (options) {
        const mainCaptionsPromise = $http.get(options.server + options.prefix + options.key + options.suffix);
        const localCaptionsPromise = $http.get(options.local + options.prefix + options.key + options.suffix)
          .catch(function () {
            // In case the local file is not found, return an empty object.
            return { data: {} };
          });
        return $q.all([mainCaptionsPromise, localCaptionsPromise])
          .then(function (results) {
            const mainCaptions = results[0].data;
            const localCaptions = results[1].data;
            return angular.extend({}, localCaptions, mainCaptions);
          }).catch(function () {
          });
      };
    })

    .config(function ($translateProvider, CAPTIONS_URLS) {
      $translateProvider.useLoader('customCaptionLoader', {
        server: CAPTIONS_URLS.MAIN_URL,
        local: CAPTIONS_URLS.LOCAL_URL,
        prefix: '/Caption_Admin_',
        suffix: '.json'
      });
      $translateProvider.preferredLanguage('en');
      $translateProvider.useLocalStorage();
    });

})();
